module.exports = __webpack_public_path__ + "static/talos-symbol-SCAG-c0b7bad0466c14f53f4543884202feca.png";